/* eslint-disable camelcase */
const checklistStatuses = [
  { name: "Draft", id: 1 },
  { name: "Completed", id: 2 }
]
const checklistModules = [
  { name: "Common", id: 1 },
  { name: "Order", id: 2 },
  { name: "Equipment", id: 3 }
]
const checklistTypes = [
  { name: "Service Jobs", id: 1 },
  { name: "Control Reports", id: 2 },
  { name: "Brakomp forms", id: 3 },
]
const checklistFormulaType = [
  { name: "Formula 1", id: 1 },
  { name: "Formula 2", id: 2 },
  { name: "Formula 3", id: 3 },
  { name: "Formula 4", id: 4 }
]

const componentStatusList = [
  {
    text: "Yes",
    value: "yes"
  },
  {
    text: "No",
    value: "no"
  },
  {
    text: "Not applicable",
    value: "not_applicable"
  }
]
const listOfFormTypes = [
  {
    text: "Text field",
    value: 1
  },
  {
    text: "Text area",
    value: 2
  },
  {
    text: "Checkbox",
    value: 3
  },
  {
    text: "Radio",
    value: 4
  },
  {
    text: "Select",
    value: 5
  },
  {
    text: "Date",
    value: 6
  },
  {
    text: "Time",
    value: 7
  },
  {
    text: "Switch",
    value: 8
  },
  {
    text: "File",
    value: 9
  },
  {
    text: "Component",
    value: 10
  },
  {
    text: "Divider",
    value: 11
  },
  {
    text: "Grid",
    value: 12
  },
  {
    text: "Signature",
    value: 13
  },
  {
    text: "Panel",
    value: 14
  },
  {
    text: "Label",
    value: 15
  },
  {
    text: "HTML",
    value: 16
  },
  {
    text: "Advanced Survey Component",
    value: 19
  },
  {
    text: "Checkpoint 123S",
    value: 20
  },
  {
    text: "Formula1 Checkpoint 123S",
    value: 22
  },
  {
    text: "Formula2 Checkpoint 123S",
    value: 23
  },
  {
    text: "Formula3 Checkpoint 123S",
    value: 24
  },
  {
    text: "Formula4 Checkpoint 123S",
    value: 25
  }
]

const standardFields = [
  {
    type: 1,
    name: "Text field",
    icon: "mdi-form-textbox"
  },
  {
    type: 2,
    name: "Text area",
    icon: "mdi-format-align-left"
  },
  {
    type: 3,
    name: "Checkbox",
    icon: "mdi-checkbox-marked-outline"
  },
  {
    type: 4,
    name: "Radio",
    icon: "mdi-radiobox-marked"
  },
  {
    type: 5,
    name: "Select",
    icon: "mdi-playlist-check"
  },
  {
    type: 6,
    name: "Date",
    icon: "mdi-calendar-today"
  },
  {
    type: 7,
    name: "Time",
    icon: "mdi-calendar-clock"
  },
  {
    type: 11,
    name: "Divider",
    icon: "mdi-minus"
  },
  {
    type: 15,
    name: "Label",
    icon: "mdi-label-outline"
  },
  {
    type: 16,
    name: "HTML",
    icon: "mdi-language-html5"
  }
]
const advancedFields = [
  {
    type: 10,
    name: "Component",
    icon: "mdi-view-compact",
    isAdvanced: true
  },
  {
    type: 13,
    name: "Signature",
    icon: "mdi-message-draw",
    isAdvanced: true
  },
  {
    type: 14,
    name: "Panel",
    icon: "mdi-view-agenda",
    isAdvanced: true
  },
  {
    type: 19,
    name: "Advanced Survey Component",
    icon: "mdi-view-compact",
    isAdvanced: true
  },
  {
    type: 20,
    name: "Checkpoint 123S",
    icon: "mdi-alpha-c-box-outline",
    isAdvanced: true
  },
  {
    type: 21,
    name: "Checkpoint Radio Status",
    icon: "mdi-alpha-c-box-outline",
    isAdvanced: true
  },
  {
    type: 22,
    name: "Formula1 Checkpoint 123S",
    icon: "mdi-newspaper-variant-outline",
    isAdvanced: true
  },
  {
    type: 23,
    name: "Formula2 Checkpoint 123S",
    icon: "mdi-newspaper-variant-outline",
    isAdvanced: true
  },
  {
    type: 24,
    name: "Formula3 Checkpoint 123S",
    icon: "mdi-newspaper-variant-outline",
    isAdvanced: true
  },
  {
    type: 25,
    name: "Formula4 Checkpoint 123S",
    icon: "mdi-newspaper-variant-outline",
    isAdvanced: true
  }
]
standardFields.forEach((element) => {
  element.isStandard = true
})
export {
  componentStatusList,
  listOfFormTypes,
  standardFields,
  advancedFields,
  checklistStatuses,
  checklistModules,
  checklistTypes,
  checklistFormulaType
}
